
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcons4K = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 30,
  viewBox: "0 0 24 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.976 12H5.024c-2.221.002-4.022 1.668-4.024 3.724v9.552c.002 2.056 1.803 3.722 4.024 3.724h13.952c2.221-.002 4.022-1.668 4.024-3.724v-9.552c-.002-2.056-1.803-3.722-4.024-3.724zm2.933 13.126c-.002 1.586-1.39 2.872-3.1 2.874H5.191c-1.712-.002-3.099-1.288-3.101-2.874v-9.252c.002-1.586 1.39-2.872 3.1-2.874h13.617c1.712.002 3.099 1.288 3.101 2.874v9.252zM11.644 7.866c.78 0 1.53.31 2.08.863a.509.509 0 0 1-.715.721 1.923 1.923 0 0 0-2.731 0 .506.506 0 1 1-.715-.72 2.937 2.937 0 0 1 2.08-.864zm-.005-3.435c1.427 0 2.797.568 3.806 1.578a.508.508 0 0 1-.36.868.51.51 0 0 1-.366-.147 4.375 4.375 0 0 0-6.171 0 .51.51 0 0 1-.866-.36c0-.136.054-.266.15-.361a5.384 5.384 0 0 1 3.807-1.578zM11.644 1c2.07 0 4.057.823 5.521 2.289a.506.506 0 0 1 0 .715.504.504 0 0 1-.355.152.503.503 0 0 1-.36-.152 6.8 6.8 0 0 0-9.612 0 .508.508 0 0 1-.716-.715A7.802 7.802 0 0 1 11.644 1z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  stroke: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"30\" viewBox=\"0 0 24 30\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" stroke=\"var(--theme-primary, #810ea9)\">\r\n            <g>\r\n                <path d=\"M17.976 11H4.024C1.803 11.002.002 12.668 0 14.724v9.552C.002 26.332 1.803 27.998 4.024 28h13.952c2.221-.002 4.022-1.668 4.024-3.724v-9.552c-.002-2.056-1.803-3.722-4.024-3.724zm2.933 13.126c-.002 1.586-1.39 2.872-3.1 2.874H4.191c-1.712-.002-3.099-1.288-3.101-2.874v-9.252c.002-1.586 1.39-2.872 3.1-2.874h13.617c1.712.002 3.099 1.288 3.101 2.874v9.252zM10.644 6.866c.78 0 1.53.31 2.08.863.096.096.15.225.15.36 0 .136-.054.266-.15.361-.095.095-.225.148-.36.147-.133 0-.26-.053-.355-.147-.361-.364-.853-.568-1.365-.568-.513 0-1.004.204-1.366.568-.197.197-.517.197-.715 0-.096-.095-.15-.225-.15-.36 0-.136.054-.265.15-.36.551-.553 1.3-.864 2.08-.864zm-.005-3.435c1.427 0 2.797.568 3.806 1.578.146.145.19.364.111.555-.079.19-.265.314-.471.313-.137.002-.269-.051-.366-.147-1.707-1.698-4.464-1.698-6.171 0-.198.196-.518.196-.716 0-.096-.096-.15-.225-.15-.36 0-.136.054-.266.15-.361 1.01-1.01 2.379-1.578 3.807-1.578zM10.644 0c2.07 0 4.057.823 5.521 2.289.197.197.197.517 0 .715-.093.096-.221.15-.355.152-.136 0-.265-.055-.36-.152-2.655-2.652-6.957-2.652-9.612 0-.202.173-.502.161-.69-.027-.187-.187-.198-.487-.026-.688C6.586.823 8.572 0 10.644 0z\" transform=\"translate(1 1)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-4-k.a5d1ab912d877c6e7a693323230973f2.svg"),
        {
          React: SvgIcons4K,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      